import { Component, OnInit } from '@angular/core'
import { SnotifyService } from 'ng-snotify'
import {EmpresaService} from "../../services/empresa/empresa.service"
import { FormBuilder, FormControl, FormGroup } from "@angular/forms"
import {forEach} from "@angular/router/src/utils/collection";

@Component({
  selector: 'app-empresa-listar',
  templateUrl: './listar.component.html',
  styleUrls: ['./listar.component.scss']
})
export class EmpresaListarComponent implements OnInit {

   /**
   * Definições de contexto Geral
   */

  public loading: Boolean = true

  public listaEmpresas: Array<any> = []

  public listaGrupos: Array<any> = [];

  public empresas: Array<any> = []

  public lastResponse: any = null

  public perPage: number = 20

  public currentPage: number = 1

  public filter: FormGroup = this.fb.group({
    empresa: new FormControl('', []),
    grupo: new FormControl('', []),
    ativo: new FormControl('1'),
    tipoEmpresa: new FormControl('MATRIZ')
  })

  public dropdownSettingsEmpresas = {
    singleSelection: false,
    idField: 'descricao',
    textField: 'descricao',
    itemsShowLimit: 8,
    selectAllText: 'Marcar todas',
    unSelectAllText: 'Desmarcar todas',
    allowSearchFilter: true
  };

    public dropdownSettingsGrupos = {
        singleSelection: false,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: true
    };

  constructor(
    private _notify: SnotifyService,
    private empresaService: EmpresaService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this._searchEmpresas()
    this._loadEmpresas()
  }

  /**
   * Métodos de interação
   */
  private _loadEmpresas(): void {
    this.loading = true

    this.empresaService.visualizarLista(this.getFilters(), this.currentPage, this.perPage).subscribe(
      ({data}:any) => {
        this.loading = false
        this.lastResponse = data
        this.listaEmpresas = this.listaEmpresas.concat(this.lastResponse.empresas.data)
      },
      error => {
        this.loading = false
        this._notify.error("Ocorreu um erro ao carregar empresas")
      }
    );

    this.empresaService.buscarEmpresasVinculadasGrupo().subscribe(({data}) => {
        const grupos = [];
        for (let i = 0; i < data.length; i++) {
            grupos.push({descricao: data[i].nome_grupo, id: data[i].id});
        }
        this.listaGrupos = grupos;
    });
  }

  private _searchEmpresas(): void  {
    this.empresaService.listar(null, '', 'todos')
    .subscribe(
      ({data}) => {

        let flags = [], output = []
        for( let i=0; i< data.empresas.length; i++) {
          if( flags[data.empresas[i].apelido]) continue
          flags[data.empresas[i].apelido] = true

          if(data.empresas[i].apelido != null)
            output.push({descricao: data.empresas[i].apelido})
        }

        this.empresas = output

      },
      error => {
        this._notify.warning('Ocorreu um erro ao carregar empresas')
      }
    )
  }

  public toFilter(): void {
    this.reset(false)
    this._loadEmpresas()
  }

  public reset(reload: boolean): void {
    this.listaEmpresas = []
    this.currentPage = 1

    if(reload) {
      Object.keys(this.filter.controls).forEach(key => {
        this.filter.controls[key].setValue(null)
      })

      this._loadEmpresas()
    }
  }

  public getFilters(): Object {
    const filter = {}

    Object.keys(this.filter.controls).forEach((_filter) => {
      filter[_filter] = this.filter.controls[_filter].value
    });

    if (filter['empresa']) {
      filter['empresa'] = filter['empresa'].map(estados => {
        return estados.descricao
      })
    }

      if (filter['grupo']) {
          filter['grupo'] = filter['grupo'].map(grupo => {
              return grupo.id;
          });
      }
      return filter;
  }

  public loadMore(): void {
    this.currentPage++
    this._loadEmpresas()
  }

  public loadPerPage($event: any): void {
    this.perPage = $event.target.value
    this.reset(false)
    this._loadEmpresas()
  }

}
